(function ($) {
    var loop = false;
    var center = true;
    var loopedSlides = null;
    // if($('.gallery-thumbs').attr('data-loop') !== '') {
    //     loop = true;
    //     center = false;
    //     loopedSlides = 50;
    // }
    var articleGallery = new Swiper('.article-gallery .swiper-container', {
        slidesPerView: 1,
        loop: loop,
        loopedSlides: loopedSlides,
        centeredSlides: true,
        navigation: {
            nextEl: '.article-gallery-next',
            prevEl: '.article-gallery-prev',
        },
    });


    var articleThumbnails = new Swiper('.gallery-thumbs .swiper-container', {
        spaceBetween: 10,
        slidesPerView: 3,
        loop: loop,
        loopedSlides: loopedSlides,
        centeredSlides: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.thumb-next',
            prevEl: '.thumb-prev',
        },
        controller: {
            control: articleGallery
        }
    });
    articleGallery.controller.control = articleThumbnails;

    var productGallery = new Swiper('.product-gallery .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10
    });

    var productThumbnails = new Swiper('.product-gallery-thumbs .swiper-container', {
        breakpointsInverse: false,
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 10,
        slideToClickedSlide: true,
        centeredSlides: true,
        autoplay: true,
        controller: {
            control: productGallery
        },
        breakpoints: {
            991: {
                direction: 'vertical',
            }
        }
    });
    productGallery.controller.control = productThumbnails;

    $('[data-fancybox="gallery"]').fancybox({
        backFocus: false,
        hash: null,
        buttons: [
            "zoom",
            "close"
        ],
    });

    $('[data-attempts-to-fancybox="gallery"]').fancybox({
        smallBtn : true,
        toolbar  : false,
        // backFocus: false,
        // hash: null,
        buttons: [
            "close"
        ],
    });

    $(document).on('click', '.gallery-thumbs .swiper-slide[data-video="true"]', function(e){
        var gallery_slide = $('.article-gallery .swiper-slide.swiper-slide-active[data-video="true"]');
        var gallery_slide_video = gallery_slide.find('video');
        if((gallery_slide.length > 0) && (gallery_slide_video.length > 0)) {
            gallery_slide_video[0].play();
            gallery_slide_video.addClass('play-v');
        }
    });


    // $(document).on('click', '.swiper-slide .video-play', function(){
    //     var thisTrigger = $(this);
    //     var thisSlide = thisTrigger.parents('.swiper-slide');
    //     var thisVideo = thisSlide.find('video');
    //     if(thisVideo.length > 0) {
    //         thisVideo[0].play();
    //         thisSlide.addClass('play-v');
    //     }
    // });
    // $('video').bind("play", function(){
    //     if($(this).parents('.swiper-slide').length > 0) {
    //         if(!($(this).parents('.swiper-slide').hasClass('play-v'))) {
    //             $(this).parents('.swiper-slide').addClass('play-v');
    //         }
    //     }
    // });
    // $('video').bind("pause ended", function(){
    //     if($(this).parents('.swiper-slide').length > 0) {
    //         if($(this).parents('.swiper-slide').hasClass('play-v')) {
    //             $(this).parents('.swiper-slide').removeClass('play-v');
    //         }
    //     }
    // });

    $(document).on('click', '.selectStageLinks__trigger', function(){
        var thisTrigger = $(this);
        var thisFilter = thisTrigger.parents('.selectStageLinks');
        if(thisFilter.hasClass('open')) {
            thisFilter.removeClass('open');
        } else {
            thisFilter.addClass('open');
        }
        $('body').on('click', function (e) {
            if (!$(e.target).closest('.selectStageLinks').length){
                $('.selectStageLinks').removeClass('open');
            }
        });
    });

    $(document).on('click', '.stageResultItem', function(){
        var thisItem = $(this);
        var thisResult = thisItem.attr('data-result');
        var thisResultID = thisItem.attr('data-result-id');
        var selectStageLinks = thisItem.parents('.selectStageLinks');
        var selectStageLinksText = selectStageLinks.find('.selectStageLinks__trigger--text');
        var stageResult = thisItem.parents('.stageResult');
        var stageResultWrapper = stageResult.find('.stageResult__wrapper');
        var stageResultWrapperHeight = stageResultWrapper.height();
        var stageResultLoader = stageResult.find('.stageResult__outerWrapper--loader');
        if(!(thisItem.hasClass('active'))) {
            stageResultLoader.addClass('active');
            selectStageLinks.removeClass('open');
            selectStageLinks.addClass('load');
            var formData = new FormData();
            formData.append('action', 'load_stage_result');
            formData.append('result', parseInt(thisResult));
            formData.append('id', parseInt(thisResultID));
            $.ajax({
                type: 'POST',
                url: postmpwp.ajax_url,
                data: formData,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    if(response.data) {
                        stageResultWrapper.css('height', stageResultWrapperHeight+'px');
                        stageResultWrapper.empty();
                        stageResultWrapper.append(response.data.html);
                        selectStageLinksText.empty().append(response.data.title);
                        selectStageLinks.find('.stageResultItem').not(thisItem).removeClass('active');
                        thisItem.addClass('active');
                        setTimeout(function(){
                            stageResultLoader.removeClass('active');
                            stageResultWrapper.removeAttr('style');
                            selectStageLinks.removeClass('load');
                        }, 500);
                    }
                },
                error: function (response) {
                    stageResultLoader.removeClass('active');
                    stageResultWrapper.removeAttr('style');
                    selectStageLinks.removeClass('load');
                }
            });
        } else {
        }
    });

})(jQuery);